export enum RoleTypes {
  TRUE_BUYER = 'True Buyer',
  TRUE_SELLER = 'True Seller',
  LISTING_REP = 'Listing Representative',
  LANDLORD_REP = 'Lessor Representative',
  TENANT = 'Tenant',
  TENANT_REP = 'Tenant Representative',
  PRIOR_TENANT = 'Prior Tenant',
  BUYER_REPRESENTATIVE = 'Buyer Representative',
  MARKETING_AGENCY = 'Marketing Agency',
  LESSEE = 'Lessee',
  LESSEE_REP = 'Lessee Representative',
  LESSOR = 'Lessor',
  SELLER_REP = 'Seller Representative',
  LEGAL_OWNER = 'Legal Owner',
  ARCHITECT = 'Architect',
  ASSET_MANAGER = 'Asset Manager',
  DEVELOPER = 'Developer',
  FUNDER = 'Funder',
  PROPERTY_MANAGER = 'Property Manager',
  TRUE_OWNER = 'True Owner',
  THIRD_PARTY_LOGISTIC = '3rd Party Logistics',
  LEGAL_BUYER = 'Legal Buyer',
  SUBLESSOR = 'Sub Lessor',
  SUBLEASE_REP = 'Sub lease Representative',
  LESSOR_REP = 'Lessor Representative',
}
